module.exports = __webpack_public_path__ + "media/pokerFlip.ca8d9487.mp3";